export default "__VITE_ASSET__WY8ZxDx0__"